import { useCallback, useState, useEffect } from "react";
import PersonaliaForm from "./components/PersonaliaForm";
import PersonaliaList from "./components/PersonaliaList";
import Checkout from "./components/Checkout";
import ErrorModal from "./components/UI/ErrorModal";
import Modal from './components/UI/Modal';
import "./App.css";

function App() {
  const [error, setError] = useState("");
  const [gegevens, setGegevens] = useState([]);
  const [modalIsShown, setModalIsShown] = useState(false);

  useEffect(() => {
    const fetchGegevens = async () => {
      const response = await fetch(
        "https://www.marchouben.nl/php/personalia-get.php"
      );

      if (!response.ok) {
        throw new Error("Something went wrong!");
      }

      const responseData = await response.json();
      console.log(responseData);
      const loadedPersonalia = responseData;

      setGegevens(loadedPersonalia);
    };

    fetchGegevens().catch((error) => {
      console.log(error.message);
    });
  }, []);

  const addPersonaliaHandler = useCallback(async function (
    enteredPersonaliaData
  ) {
    console.log(enteredPersonaliaData);

    const response = await fetch(
      "https://www.marchouben.nl/php/personalia-post.php",
      {
        method: "POST",
        body: JSON.stringify(enteredPersonaliaData),
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );

    const data = await response.json();
    console.log(data);

    if (data.status !== "OK") {
      setError(data.error);
    } else {
      setError("");
    }

    const fetchGegevens = async () => {
      const response = await fetch(
        "https://www.marchouben.nl/php/personalia-get.php"
      );

      if (!response.ok) {
        throw new Error("Something went wrong!");
      }

      const responseData = await response.json();
      console.log(responseData);
      const loadedPersonalia = responseData;

      setGegevens(loadedPersonalia);
    };

    fetchGegevens().catch((error) => {
      console.log(error.message);
    });
  },
  []);

  const errorHandler = () => {
    setError("");
  };

  const activeerModal = () => {
    setModalIsShown(true);
  };

  const cancelHandler = () => {
    // De modal sluiten of invoervelden leeg maken
    console.log("Cancel button is ingedrukt");
    setModalIsShown(false);
  }

  // <p className="error">{error}</p>
  return (
    <div className="app">
      <main>
        <PersonaliaForm onAddPersonalia={addPersonaliaHandler} />
        {modalIsShown && (
          <Modal>
            <Checkout
              onConfirm={addPersonaliaHandler}
              onCancel={cancelHandler}
            />
          </Modal>
        )}
        <button onClick={activeerModal}>Activeer modal scherm</button>
        {error.trim().length !== 0 ? (
          <ErrorModal title={error} message={error} onConfirm={errorHandler} />
        ) : (
          <p className="success">{error}</p>
        )}
        <PersonaliaList gegevens={gegevens} />
      </main>
    </div>
  );
}

export default App;